module.exports = __webpack_public_path__ + "static/media/Nexus 5x.7625f87e.png";